/* eslint-disable react/destructuring-assignment */

import { faFileVideo } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { connect } from 'react-redux';
import { FieldArray } from 'redux-form';
import Collapsible from 'react-collapsible';

import { DataRequestActionTypes } from '../../../constants/actionTypes';
import { FormId } from '../../../constants/formId';
import { ClippingPlatformState } from '../../../store/clippingPlatformState';
import { AppTextField } from '../../form/appTextField';
import FormModal from '../../modal/formModal';
import { AppFileField } from '../../form/appFileField';
import { required, urlValidator } from '../../form/formValidations';
import * as NotificationHelper from '../../../helpers/notificationHelper';
import EditableFieldArray from '../../form/editableFieldArray';

import styles from './generateVgVideoCeremonyForm.module.scss';

type GenerateVgVideoCeremonyFormOwnProps = {
  eventId: string;
  vgProcessingJob?: string;
};

type GenerateVgCeremonyFormStateProps = {
  formErrors: any;
};

type GenerateVgVideoCeremonyFormProps = GenerateVgCeremonyFormStateProps & GenerateVgVideoCeremonyFormOwnProps;

// eslint-disable-next-line react/prefer-stateless-function
class GenerateVgVideoCeremonyForm extends React.Component<GenerateVgVideoCeremonyFormProps> {
  private static showSuccessMessage() {
    NotificationHelper.success(
      'Your request has been sent. Please wait for the video to be generated. This might take a few minutes.',
    );
  }

  private renderTrigger(sectionName: string, fieldName: string) {
    return (
      <span>
        {sectionName}
        {this.props.formErrors && this.props.formErrors[fieldName] && (
          <span className={styles.error}>Invalid URL. Please check that all URLs are filled.</span>
        )}
      </span>
    );
  }

  private renderVideoLinkList = (indexName: string, fieldName: string) => ({ fields, readonly = false }: any) => {
    const subField = (link: string) => (
      <AppTextField name={link} label="Azure URL" validate={[required, urlValidator]} />
    );

    return (
      <EditableFieldArray
        fields={fields}
        newField={() => ''}
        indexName={indexName}
        fieldName={fieldName}
        subFields={subField}
        readonly={readonly}
        errors={this.props.formErrors && this.props.formErrors[indexName]}
      />
    );
  };

  private renderPreRollVideosLinkList = this.renderVideoLinkList('preRollVideosLinkList', 'PreRoll Video');

  private renderPostRollVideosLinkList = this.renderVideoLinkList('postRollVideosLinkList', 'PostRoll Video');

  public render() {
    return (
      <FormModal
        formId={FormId.GenerateVgVideoCeremony}
        formTitle={
          this.props.vgProcessingJob ? 'Please wait for the video to be generated' : 'Generate VG Video Ceremony'
        }
        submitActionType={DataRequestActionTypes.GenerateVgVideoCeremonyRequested}
        reduxData={{ eventId: this.props.eventId }}
        buttonIcon={faFileVideo}
        invertedButtonColours
        disabled={!!this.props.vgProcessingJob}
        onSuccessCallback={GenerateVgVideoCeremonyForm.showSuccessMessage}
      >
        <AppFileField
          name="slideBackgroundImage"
          label="Slide background image"
          extensions={['jpg', 'jpeg', 'png']}
          validate={[required]}
        />
        <AppFileField
          name="videoBackgroundImage"
          label="Video background image"
          extensions={['jpg', 'jpeg', 'png']}
          validate={[required]}
        />
        <AppFileField name="backgroundAudio" label="Background audio" extensions={['mp3', 'wav', 'm4a']} />

        <Collapsible trigger={this.renderTrigger('PreRoll Videos', 'preRollVideosLinkList')}>
          <FieldArray name="preRollVideosLinkList" component={this.renderPreRollVideosLinkList} />
        </Collapsible>

        <Collapsible trigger={this.renderTrigger('PostRoll Videos', 'postRollVideosLinkList')}>
          <FieldArray name="postRollVideosLinkList" component={this.renderPostRollVideosLinkList} />
        </Collapsible>
      </FormModal>
    );
  }
}

function mapStateToProps(state: ClippingPlatformState): GenerateVgCeremonyFormStateProps {
  const formData = state.form[FormId.GenerateVgVideoCeremony];

  return {
    formErrors: formData && (formData as any).syncErrors,
  };
}

export default connect(mapStateToProps)(GenerateVgVideoCeremonyForm);
